module.exports = __webpack_public_path__ + "img/trash.b763eb24.svg";